const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllergyImmunology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M27.322,6.675 c-0.051-0.067-1.284-1.653-3.483-2.7c-2.034-0.969-5.3-1.627-9.315,0.745c-0.144,0.09-3.53,2.259-3.976,6.196l-0.002,0.02 l0.001,0.02c0.002,0.03,0.041,0.691,0.131,1.123l-2.734,3.361c-0.046,0.055-0.327,0.415-0.204,0.93 c0.152,0.636,0.843,1.209,2.055,1.705l0.099,2.149l2.459,0.124L9.9,20.514l0.098,1.61c-0.02,0.146,0.069,1.059,0.438,1.442 c0.504,0.524,1.187,0.763,2.342,0.668l0.012-0.001c0.008-0.001,0.81-0.102,1.253,0.311c0.223,0.208,0.324,0.525,0.299,0.942 l0.024,2.947h10.847c-0.122-1.114-0.252-5.999,2.216-9.653c0.107-0.134,1.212-1.554,1.77-3.709 C29.733,13.016,29.838,9.892,27.322,6.675z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.808,10.643 c0.005,0.296-0.232,0.541-0.528,0.545c-0.296,0.005-0.54-0.232-0.545-0.528c-0.005-0.296,0.232-0.541,0.528-0.545 C13.559,10.111,13.804,10.347,13.808,10.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.73,11.54 c0.004,0.224-0.175,0.409-0.399,0.412c-0.224,0.004-0.409-0.175-0.412-0.399c-0.004-0.224,0.175-0.409,0.399-0.412 C16.542,11.137,16.726,11.315,16.73,11.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.285,11.248 c0.004,0.224-0.175,0.409-0.399,0.412c-0.224,0.003-0.409-0.175-0.412-0.399c-0.003-0.224,0.175-0.409,0.399-0.412 C15.096,10.845,15.281,11.024,15.285,11.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M17.49,13.203 c0.004,0.224-0.175,0.409-0.399,0.412c-0.224,0.004-0.409-0.175-0.412-0.399c-0.004-0.224,0.175-0.409,0.399-0.412 C17.301,12.8,17.486,12.979,17.49,13.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M17.438,14.854 c0.003,0.224-0.175,0.409-0.399,0.412c-0.224,0.004-0.409-0.175-0.412-0.399c-0.004-0.224,0.175-0.409,0.399-0.412 C17.249,14.451,17.434,14.63,17.438,14.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.448,16.536 c0.003,0.224-0.175,0.409-0.399,0.412c-0.224,0.003-0.409-0.175-0.412-0.399s0.175-0.409,0.399-0.412 C15.26,16.133,15.444,16.312,15.448,16.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M17.145,17.046 c0.004,0.224-0.175,0.409-0.399,0.412c-0.224,0.004-0.409-0.175-0.412-0.399c-0.004-0.224,0.175-0.409,0.399-0.412 C16.957,16.643,17.142,16.822,17.145,17.046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M18.685,15.908 c0.004,0.282-0.22,0.514-0.502,0.519c-0.282,0.004-0.514-0.22-0.519-0.502c-0.005-0.282,0.22-0.514,0.502-0.519 C18.448,15.401,18.681,15.626,18.685,15.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.225,15.201 c0.004,0.282-0.22,0.514-0.502,0.519c-0.282,0.005-0.514-0.22-0.519-0.502c-0.005-0.282,0.22-0.514,0.502-0.519 C15.988,14.694,16.221,14.919,16.225,15.201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M18.636,17.768 c0.004,0.282-0.22,0.514-0.502,0.519c-0.282,0.004-0.514-0.22-0.519-0.502c-0.004-0.282,0.22-0.514,0.502-0.519 C18.4,17.261,18.632,17.486,18.636,17.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M18.458,19.683 c0.004,0.282-0.22,0.514-0.502,0.519c-0.282,0.005-0.514-0.22-0.519-0.502c-0.004-0.282,0.22-0.514,0.502-0.519 C18.221,19.176,18.453,19.401,18.458,19.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M17.461,21.218 c0.005,0.282-0.22,0.514-0.502,0.519s-0.514-0.22-0.519-0.502c-0.005-0.282,0.22-0.514,0.502-0.519 C17.224,20.711,17.456,20.936,17.461,21.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M17.086,19.05 c0.004,0.267-0.209,0.488-0.477,0.492c-0.267,0.004-0.488-0.209-0.492-0.477c-0.004-0.267,0.209-0.488,0.477-0.492 C16.861,18.569,17.081,18.783,17.086,19.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.599,17.791 c0.004,0.267-0.209,0.488-0.477,0.492c-0.267,0.004-0.488-0.209-0.492-0.477s0.209-0.488,0.477-0.492 C15.374,17.31,15.594,17.523,15.599,17.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.813,16.654 c0.004,0.268-0.209,0.488-0.477,0.492c-0.268,0.004-0.488-0.209-0.492-0.477c-0.004-0.267,0.209-0.488,0.477-0.492 C13.588,16.173,13.809,16.386,13.813,16.654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.111,17.48 c0.004,0.267-0.209,0.488-0.477,0.492c-0.267,0.004-0.488-0.209-0.492-0.477c-0.004-0.268,0.209-0.488,0.477-0.492 C11.886,16.999,12.106,17.212,12.111,17.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.981,18.183 c0.004,0.253-0.198,0.461-0.451,0.466c-0.253,0.004-0.462-0.198-0.465-0.451c-0.004-0.253,0.198-0.462,0.451-0.465 C13.769,17.728,13.977,17.93,13.981,18.183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M14.923,19.74 c0.004,0.253-0.198,0.461-0.451,0.465c-0.253,0.004-0.462-0.198-0.466-0.451c-0.004-0.253,0.198-0.462,0.451-0.465 C14.71,19.285,14.919,19.486,14.923,19.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.063,20.612 c0.004,0.253-0.198,0.462-0.451,0.465c-0.253,0.004-0.461-0.198-0.466-0.451c-0.004-0.253,0.198-0.461,0.451-0.465 C15.851,20.157,16.059,20.359,16.063,20.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.133,22.224 c0.004,0.253-0.198,0.461-0.451,0.466c-0.253,0.004-0.462-0.198-0.465-0.451c-0.004-0.253,0.198-0.461,0.451-0.465 C14.92,21.769,15.129,21.971,15.133,22.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M14.236,20.982 c0.004,0.253-0.198,0.462-0.451,0.465c-0.253,0.004-0.462-0.198-0.466-0.451c-0.004-0.253,0.198-0.462,0.451-0.465 C14.023,20.527,14.231,20.728,14.236,20.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.639,19.734 c0.004,0.253-0.198,0.462-0.451,0.465c-0.253,0.004-0.461-0.198-0.466-0.451c-0.004-0.253,0.198-0.462,0.451-0.466 C13.427,19.279,13.635,19.481,13.639,19.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.268,19.127 c0.004,0.253-0.198,0.462-0.451,0.465c-0.253,0.004-0.462-0.198-0.466-0.451c-0.004-0.253,0.198-0.462,0.451-0.466 C12.055,18.672,12.264,18.874,12.268,19.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.45,21.202 c0.004,0.253-0.198,0.462-0.451,0.465c-0.253,0.004-0.462-0.198-0.465-0.451c-0.004-0.253,0.198-0.462,0.451-0.466 C12.237,20.747,12.445,20.949,12.45,21.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.24,22.612 c0.004,0.253-0.198,0.461-0.451,0.466c-0.253,0.004-0.462-0.198-0.465-0.451c-0.004-0.253,0.198-0.461,0.451-0.466 C13.028,22.158,13.236,22.359,13.24,22.612z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M8.946,20.901c0,0-0.001,0-0.002,0c0-0.001,0.001-0.001,0.001-0.001 c-1.759-0.084-2.78-0.175-3.365,0.108c-0.585,0.282-0.794,1.062-0.467,1.741c0,0,0,0.001,0,0.001c0,0,0,0.001,0,0.001 c0.328,0.679,1.068,1.001,1.653,0.718S7.917,22.33,8.946,20.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M8.912,22.996C8.912,22.996,8.912,22.996,8.912,22.996c-0.001,0-0.001-0.001-0.001-0.001 c-1.015,0.647-1.621,1-1.836,1.389C6.86,24.773,7.051,25.29,7.502,25.54c0,0,0,0,0.001,0c0,0,0,0,0.001,0 c0.451,0.25,0.991,0.137,1.206-0.252C8.925,24.9,8.902,24.199,8.912,22.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M5.987,24.189C5.987,24.189,5.987,24.19,5.987,24.189C5.986,24.189,5.986,24.189,5.987,24.189 c-0.857,0.455-1.366,0.699-1.564,0.998c-0.198,0.299-0.077,0.726,0.269,0.956c0,0,0,0,0,0c0,0,0,0,0,0 c0.346,0.229,0.787,0.173,0.985-0.125C5.876,25.72,5.903,25.156,5.987,24.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M4.855,20.679C4.855,20.679,4.854,20.679,4.855,20.679C4.854,20.678,4.854,20.678,4.855,20.679 c-0.89-0.387-1.398-0.633-1.755-0.601c-0.357,0.031-0.616,0.392-0.58,0.806c0,0,0,0,0,0c0,0,0,0,0,0 c0.036,0.414,0.355,0.724,0.712,0.692C3.588,21.546,4.046,21.215,4.855,20.679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M3.995,23.192C3.995,23.192,3.995,23.192,3.995,23.192C3.995,23.192,3.995,23.191,3.995,23.192 c-0.969-0.044-1.532-0.091-1.854,0.066c-0.322,0.157-0.435,0.587-0.253,0.96c0,0,0,0,0,0c0,0,0,0,0,0 c0.182,0.373,0.59,0.549,0.912,0.392C3.123,24.454,3.432,23.981,3.995,23.192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M7.901,19.774C7.901,19.774,7.901,19.773,7.901,19.774C7.901,19.773,7.901,19.773,7.901,19.774 c-0.654-0.717-1.018-1.149-1.357-1.265c-0.338-0.117-0.723,0.107-0.858,0.499c0,0,0,0,0,0c0,0,0,0,0,0 c-0.136,0.392,0.029,0.806,0.367,0.923C6.391,20.048,6.944,19.933,7.901,19.774z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergyImmunology);
export default __webpack_public_path__ + "static/media/allergy_immunology.74457699584a49471e4a344a9d19610e.svg";
export { ForwardRef as ReactComponent };